import { render } from "./base-info.vue?vue&type=template&id=6a11bae6&scoped=true&ts=true"
import script from "./base-info.vue?vue&type=script&lang=ts"
export * from "./base-info.vue?vue&type=script&lang=ts"

import "./base-info.vue?vue&type=style&index=0&id=6a11bae6&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a11bae6"]])

export default __exports__